module.exports = __webpack_public_path__ + "media/images/assignment/unlink-32fb116c59a96caa78f7e0a4bc94e1d5.svg";